export default __webpack_public_path__ + "static/media/Landing_page.4f79ed82.png";